import get from 'lodash/get'

export default function errors(state = [], action = {}) {
  const REQUEST_PENDING = action.type.includes('_PENDING')
  const REQUEST_REJECTED = action.type.includes('_REJECTED')

  switch (action.type) {
    case 'ADD_ERROR':
      return [action.payload, ...state]

    default:
      break
  }

  switch (true) {
    case REQUEST_PENDING:
      return []

    case REQUEST_REJECTED: {
      // These are handled explicitly in the relevant route.
      // TODO: a nicer way of doing this?!
      if (
        action.type === 'CREATE_LEAD_IMPORT_REJECTED' &&
        action.payload?.response?.status === 422
      ) {
        return [
          'There are errors with this import, so no leads have been created. ' +
            ' Correct the errors, then try again.',
          ...state,
        ]
      }

      if (
        action.type === 'UPDATE_FUNERAL_PLAN_REJECTED' &&
        action.payload?.response?.status === 422
      ) {
        return [...state]
      }

      /** Handled in routes/funeral-plans/celebration-interest-editable.tsx,
       * which keeps checking for the payment and then shows its own "Payment
       * failed" card */
      if (
        action.type === 'ADD_FUNERAL_PLAN_CELEBRATION_REJECTED' &&
        get(action, 'payload.response.data.errors[0].code') ===
          'celebration_payment_not_found'
      ) {
        return [...state]
      }

      if (action.type === 'GENERATE_FUNERAL_PLAN_DOCUMENTS_REJECTED') {
        return [...state]
      }

      /** Handled in components/lead-event-history, which shows its own 8x8
       * warning with a Try again button */
      if (action.type === 'FETCH_EIGHT_X_EIGHT_EVENTS_FOR_CUSTOMER_REJECTED') {
        return [...state]
      }

      const errors = get(action, 'payload.response.data.errors', [
        'Something went wrong. Please try refreshing.',
      ])

      return errors
    }

    default:
      return state
  }
}
